import React, { useMemo, createContext, useContext } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useExpertPendingQuestions } from "./ExpertPendingQuestionsHook";
// Set the default state values for each context
export const ExpertPendingQuestionsContext = /*#__PURE__*/createContext({});
export const ExpertPendingQuestionsContextProvider = ({
  children
}) => {
  const pendingContext = useExpertPendingQuestions();
  const pendingAllocationContext = useMemo(() => ({
    ...pendingContext
  }), [pendingContext]);
  return /*#__PURE__*/React.createElement(ExpertPendingQuestionsContext.Provider, {
    value: pendingAllocationContext
  }, children);
};
export const useExpertPendingQuestionsContext = () => {
  return useContext(ExpertPendingQuestionsContext);
};
ExpertPendingQuestionsContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};